fragment ImageFields on ImageInterface {
  id
  url
  originalImageUrl
  history {
    id
    type
    timestamp
    userId
    __typename
  }
  companyId
  __typename
}

mutation EditImage($input: EditImageInput!) {
  editImage(input: $input) {
    ... on GeneratedImage {
      ...ImageFields
      modelName
      topicId
      __typename
    }
    ... on UserImage {
      ...ImageFields
      topicId
      __typename
    }
    ... on StockImage {
      ...ImageFields
      license
      provider
      externalId
      __typename
    }
    ... on StockPhoto {
      ...ImageFields
      license
      provider
      externalId
      __typename
    }
    __typename
  }
}
